import { useQuery } from '@tanstack/react-query';

import { PluginDealIndividualsFormResponse } from '../../../../types/plugins';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { unwrapNonPaginatedResponseDataAs } from '../../../logic/unwrapNonPaginatedResponseDataAs';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { PLUGIN_BASE_PATH } from '../../constants/pluginBasePath';
import {
  DEAL_INDIVIDUALS_FORM_PLUGIN_KEY,
  runDealIndividualsForm,
} from '../../requests/runDealIndividualsForm';

export const useDealIndividualsForm = (
  applicationUuid: string,
  options?: { enabled?: boolean },
) => {
  const { constructPost } = useRequestConstructor();

  const { data, ...rest } = useQuery<
    NonPaginatedResponse<PluginDealIndividualsFormResponse> | undefined
  >({
    queryKey: [
      PLUGIN_BASE_PATH,
      DEAL_INDIVIDUALS_FORM_PLUGIN_KEY,
      applicationUuid,
    ],
    queryFn: () =>
      runDealIndividualsForm(constructPost, {
        params: { uuid: applicationUuid },
      }),
    enabled: !!applicationUuid,
    ...options,
  });

  return { ...unwrapNonPaginatedResponseDataAs(data, 'formData'), ...rest };
};
